(function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(root) {
    if (reduceMotion) {
      root.querySelectorAll('.zerra-reveal').forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const items = root.querySelectorAll('.zerra-reveal:not(.is-visible)');
    if (!items.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    items.forEach((el) => observer.observe(el));
  }

  function autoMarkSections() {
    document.querySelectorAll(
      '.zerra-section .zerra-container > *, .zerra-hero__slide > *, .zerra-categories__list > *, .zerra-testimonials__grid > *, .zerra-voices__list > *, .zerra-voices__layout > *, .zerra-voices__header, .zerra-voices__stage-wrap, .zerra-voices__chrome, .zerra-products__grid > *, .zerra-features-light__grid > *, .zerra-reasons__layout > *, .zerra-reasons__list > *, .zerra-why__grid > *, .zerra-why__strip > *, .zerra-finder__row > *, .zerra-lifestyle__layout > *, .zerra-cta-banner__content > *, .zerra-cta-banner__grid > *, .zerra-footer__nav > *, .zerra-footer__top, .zerra-footer__bottom, .zerra-about .zerra-container > *, .zerra-pdp__crumb, .zerra-pdp__buy, .zerra-pdp__feature, .zerra-pdp__tabs, .zerra-coll-hero__copy, .zerra-coll-hero__visual, .zerra-coll-hero__bar-grid > *'
    ).forEach((el, i) => {
      if (el.classList.contains('zerra-reveal')) return;
      el.classList.add('zerra-reveal');
      const delay = Math.min(i % 5, 4);
      if (delay > 0) el.classList.add(`zerra-reveal--delay-${delay}`);
    });
  }

  function parseCountTarget(text) {
    const raw = String(text || '').trim();
    const match = raw.match(/^(.*?)(\d[\d.\s]*)(.*)$/);
    if (!match) return null;
    return {
      prefix: match[1],
      target: parseInt(match[2].replace(/[.\s]/g, ''), 10) || 0,
      suffix: match[3],
    };
  }

  function runCounter(el, parsed) {
    const duration = 900;
    const start = performance.now();
    const ease = (t) => 1 - Math.pow(1 - t, 3);
    const format = (n) => parsed.prefix + String(Math.round(n)) + parsed.suffix;

    el.textContent = format(0);
    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      el.textContent = format(parsed.target * ease(t));
      if (t < 1) requestAnimationFrame(tick);
      else el.textContent = format(parsed.target);
    };
    requestAnimationFrame(tick);
  }

  function initCounters(root) {
    const nodes = (root || document).querySelectorAll('[data-zerra-count]:not([data-zerra-count-ready])');
    if (!nodes.length) return;

    const groups = new Map();
    nodes.forEach((el) => {
      el.setAttribute('data-zerra-count-ready', '');
      const parsed = parseCountTarget(el.getAttribute('data-zerra-count') || el.textContent);
      if (!parsed) return;
      const group = el.closest('[data-zerra-count-group]') || el;
      if (!groups.has(group)) groups.set(group, []);
      groups.get(group).push({ el, parsed });
      el.textContent = parsed.prefix + '0' + parsed.suffix;
    });

    groups.forEach((items, group) => {
      const startAll = () => {
        items.forEach(({ el, parsed }) => {
          if (reduceMotion) {
            el.textContent = parsed.prefix + parsed.target + parsed.suffix;
            return;
          }
          runCounter(el, parsed);
        });
      };

      if (reduceMotion) {
        startAll();
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            startAll();
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.35 }
      );
      observer.observe(group);
    });
  }

  function boot(root) {
    autoMarkSections();
    initReveals(root || document);
    initCounters(root || document);
  }

  document.addEventListener('DOMContentLoaded', () => boot(document));
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
